import React, { Component } from 'react';
import Loading from "./../../elements/loading";
import RevisionReportsLayout from "../../templates/revision_reports";
import ReportsExpensesEditForm from '../../elements/revision/reports_expenses';

class RevisionReportsExpenses extends Component{
	render (){
		let { revision } = this.props;
		return (
			revision.isFetching ? <Loading/>:<ReportsExpensesEditForm {...this.props}/>
		)
	}

	componentWillMount() {
		let { modality, state, municipality } = this.props.match.params;
		this.props.reset('reports');
		this.props.fetchRevisionReports('project-report-expenses',modality, state, municipality);
	}

	componentWillReceiveProps(newprops) {
		let { modality, state, municipality } = newprops.match.params;

		if(newprops.match.params !== this.props.match.params) {

			this.props.reset('revision.reports.expenses.agency');
			this.props.fetchRevisionReports('project-report-expenses',modality, state, municipality);
		}
	}
}

export default RevisionReportsLayout(RevisionReportsExpenses, {subnav: 2});


// WEBPACK FOOTER //
// ./src/layouts/revision/reports_expenses.jsx